/**
 * @file featuredSection.component.tsx
 * @path apps/website/src/features/services/components/featuredSection.component.tsx
 * @description
 */

import { cn } from "@sirbastians/utils";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import { Service } from "@sirbastians/types";
import { services } from "@/data";
import { TourCard } from "../common";
import { makeLink, NAV_LINKS } from "@/config";

const gridItemClasses = [
  "md:col-span-1 md:row-span-1",
  "md:col-span-1 md:row-span-2",
  "md:col-span-2 md:row-span-2",
  "md:col-span-1 md:row-span-2",
  "md:col-span-2 md:row-span-1",
  "md:col-span-1 md:row-span-1",
];

export const FeaturedSection = () => {
  const featuredTours: Service[] = useMemo(
    () =>
      services.filter((service) => service.category === "Tours").slice(0, 6),
    [],
  );

  return (
    <section className="container py-16 sm:py-24">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:auto-rows-[240px]">
        {featuredTours.map((service, index) => {
          const gridClass = gridItemClasses[index % gridItemClasses.length];
          const destinationPath = makeLink.service(service.slug);

          return (
            <Link
              key={service.slug}
              to={destinationPath}
              className={cn(
                "relative block rounded-3xl overflow-hidden shadow-none transition-all duration-500 group",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
                "aspect-[4/3]",
                "md:aspect-auto",
                gridClass,
                index >= 3 && "hidden md:block",
              )}
            >
              <TourCard service={service} />
            </Link>
          );
        })}
      </div>
    </section>
  );
};
